import React, { useState, useEffect } from "react";
import "./index.css";

const Preloader = ({ onComplete }) => {
    const translations = [
        "Hola",      // Spanish
        "Bonjour",   // French
        "Hallo",     // German
        "Ciao",      // Italian
        "こんにちは", // Japanese
        "你好",        // Chinese
        "안녕하세요",   // Korean
        "Привет",    // Russian
        "नमस्ते",    // Hindi
        "Merhaba",   // Turkish
        "Olá",       // Portuguese
        "Sawubona",  // Zulu
        "مرحبا",     // Arabic
        "Chào",      // Vietnamese
        "Γειά σας",  // Greek
        "Salve",     // Latin
        "Shalom",    // Hebrew
        "Hei",       // Finnish
        "Halo" ,      // Indonesian
        "Hello",     // English
    ];
    
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => {
                if (prev < translations.length - 1) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    setTimeout(onComplete, 1000); // Delay before hiding preloader
                    return prev;
                }
            });
        }, 100); // Change translation every second
        return () => clearInterval(interval);
    }, [onComplete]);

    return (
        <div className="preloader">
            <div className="translation text-4xl text-white ">{translations[currentIndex]}</div>
        </div>
    );
};

export default Preloader;
